export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_FIELDS = 'UPDATE_FIELDS';
export const SUBMITTING_START = 'SUBMITTING_START';
export const SUBMITTING_END = 'SUBMITTING_END';
export const SUBMITTING_SUCCESS = 'SUBMITTING_SUCCESS';
export const RESET_SUBMISSION = 'RESET_SUBMISSION';
export const SUBMITTING_VALIDATION_ERRORS = 'SUBMITTING_VALIDATION_ERRORS';
export const SUBMITTING_PROCESSING_ERRORS = 'SUBMITTING_PROCESSING_ERRORS';
export const LOADING_FEATURES_START = 'LOADING_FEATURES_START';
export const LOADING_FEATURES_SUCCESS = 'LOADING_FEATURES_END';

export function loadingStart() {
  return { type: LOADING_START };
}

export function loadingEnd() {
  return { type: LOADING_END };
}

export function updateConfig(config) {
  return {
    type: UPDATE_CONFIG,
    payload: { config },
  };
}

export function updateFields(fields) {
  return {
    type: UPDATE_FIELDS,
    payload: { fields },
  };
}

export function submittingStart() {
  return { type: SUBMITTING_START };
}

export function submittingEnd() {
  return { type: SUBMITTING_END };
}

export function submittingSuccess(emailAttached) {
  return {
    type: SUBMITTING_SUCCESS,
    payload: { emailAttached },
  };
}

export function resetSubmission() {
  return { type: RESET_SUBMISSION };
}

export function submittingValidationErrors(errors) {
  return {
    type: SUBMITTING_VALIDATION_ERRORS,
    payload: { errors },
  };
}

export function submittingProcessingErrors() {
  return { type: SUBMITTING_PROCESSING_ERRORS };
}

export function loadingFeaturesStart() {
  return { type: LOADING_FEATURES_START };
}

export function loadingFeaturesEnd(features) {
  return { type: LOADING_FEATURES_SUCCESS, payload: { features } };
}
